import dlv from 'dlv';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import * as shortcodes from 'remark-shortcodes';
import { EntityContext, shortcodeMap } from '../EntityContent/Shortcode';
import Galleries from '../Galleries';
import Image from '../Image';
import { defaultRenderers } from '../Markdown';
import { Infrastructure, Overview, Payment, Position } from './common';
import Progress from './Progress';
function RawFloors({ floors }) {
    return (React.createElement("div", { className: "flex flex-wrap nl2 nr2 nl3-ns nr3-ns" }, floors.map((x, idx) => (React.createElement("div", { key: idx, className: "w-100 w-third-ns pa2 pa3-ns" },
        React.createElement("div", { className: "ba b--light-gray bg-white" },
            React.createElement(Image, { src: x.image.remoteUrl, id: x.image.id }),
            React.createElement("div", { className: "pa2 bt b--light-gray" }, x.title),
            React.createElement(Galleries, { images: x.rooms || [] })))))));
}
function Floors() {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const floors = dlv(entity, 'floors');
        return React.createElement(RawFloors, { floors: floors });
    }));
}
function ShortcodeRenderer(props) {
    const { identifier, attributes } = props;
    const Component = {
        ...shortcodeMap,
        floors: Floors,
        infrastructure: Infrastructure,
        overview: Overview,
        position: Position,
        progress: Progress,
        payment: Payment,
    }[identifier];
    if (!Component) {
        return null;
    }
    return React.createElement(Component, Object.assign({}, attributes));
}
const renderers = {
    ...defaultRenderers,
    shortcode: ShortcodeRenderer,
};
function RealProjectContent({ entity }) {
    return (React.createElement(EntityContext.Provider, { value: entity },
        React.createElement(ReactMarkdown, { source: dlv(entity, 'content.md') || '', plugins: [shortcodes], renderers: renderers })));
}
export default RealProjectContent;
//# sourceMappingURL=index.js.map